import { prompt, type PromptDefinition } from './models';

export const CONSULTANT_PROMPTS = [
    prompt(
        'Understand it',
        'What is the documented scope of advice requested for this building?',
        'Which buildings have unclear scopes in their consulting briefs?'
    ),
    prompt(
        'Find evidence',
        'Which source documents support the current assessment of this building?',
        'Which buildings have the weakest source evidence for their current assessments?'
    ),
    prompt(
        'Understand it',
        "What assumptions and limitations are stated in this building's advisory reports?",
        "Compare stated assumptions and limitations across my buildings' advisory reports."
    ),
    prompt(
        'Find evidence',
        'Find consulting briefs for this building concerning…',
        'Find consulting briefs across my buildings concerning…',
        'prefill'
    ),
    prompt(
        'Understand it',
        "Which recommendations in this building's advisory reports remain open?",
        'Which buildings have unaddressed advisory recommendations?'
    ),
    prompt(
        'Coordinate people',
        "What stakeholder questions are recorded for this building's assessment?",
        'Which buildings have unanswered stakeholder questions in their assessment records?'
    ),
    prompt(
        'Find evidence',
        'Where do expert reports disagree about this building?',
        'Which buildings have conflicting expert reports requiring reconciliation?'
    ),
    prompt(
        'Find evidence',
        'Find specialist assessments for this building relating to…',
        'Find specialist assessments across my buildings relating to…',
        'prefill'
    ),
    prompt(
        'Understand it',
        'What evidence would help validate the recommendations for this building?',
        'Which buildings need further evidence before advisory recommendations can be validated?'
    ),
    prompt(
        'Plan change',
        'Which dependencies affect implementation of advice for this building?',
        'Compare documented dependencies on implementing advice across my buildings.'
    ),
    prompt(
        'Understand it',
        "Summarise this building's advisory findings with their source limitations.",
        'Summarise common advisory themes and exceptions across my buildings.'
    ),
    prompt(
        'Find evidence',
        'Prepare an evidence-based advisory summary for this building about…',
        'Prepare a comparative advisory summary across my buildings about…',
        'prefill'
    ),
] as const satisfies readonly PromptDefinition[];
